import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetTimelineByPracticeId = createAsyncThunk(
    'timelines/getTimelineByPracticeId',
    async (practiceId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `api/Marketplace/Engagements/practice/${practiceId}`
            );

            if (response.status !== 200) {
                createNotification(
                    'There was an error while loading Engagement data.',
                    'error'
                );
                throw new Error('Failed to fetch Engagement data');
            }

            const engagement = response.data;
            return engagement;
        } catch (error) {
            createNotification(
                'There was an error while loading engagement data.',
                'error'
            );
            throw error;
        }
    }
);
